module.exports = "/fonts/mpn-logotype-d-206c7e8f74b1861de804a1d97daf4468.svg";